import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';

const SavLines = ({ lines, handleCreateOrUpdateSavOrder }) => {
  const handleRemoveItem = async (lineId) => {
    const newLines = lines?.filter((line) => lineId !== line._id);
    await handleCreateOrUpdateSavOrder(newLines);
  };

  const handleChangeQuantity = async (value, id) => {
    const newLines = lines?.map((line) =>
      line._id === id ? { ...line, quantity: value, isAllocated: null } : line
    );
    await handleCreateOrUpdateSavOrder(newLines);
  };

  if (lines?.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          mb: 1,
          mt: 1,
          p: 1,
          border: '1px solid rgb(19 64 123 / 24%)',
          color: 'rgb(19 64 123 / 44%)',
          width: '510px',
          borderRadius: '4px',
        }}
      >
        <Typography>Aucun produit</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
      {lines?.map((line) => (
        <Box
          key={line.reference}
          sx={{ display: 'flex', flexDirection: 'row' }}
        >
          <FormControl
            sx={{ width: '400px', marginRight: '10px' }}
            variant="outlined"
          >
            <OutlinedInput
              placeholder="Référence de la pièce ou du colis"
              type={'text'}
              size="small"
              disabled
              sx={{ color: 'black !important' }}
              value={line.internalProduct}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={'ajouter une pièce ou un colis'}
                    onClick={() => handleRemoveItem(line._id)}
                    edge="end"
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl variant="outlined" sx={{ width: '100px' }}>
            <TextField
              type="number"
              label="Quantité"
              value={line?.quantity || 1}
              onChange={(e) => {
                const value = e.target.value;
                // Validation pour s'assurer que la valeur reste entre 1 et 500
                if (value === '') {
                  handleChangeQuantity(1, line._id);
                  return;
                }
                const numValue = parseInt(value, 10);
                if (isNaN(numValue)) {
                  return; // Ignorer les valeurs non numériques
                }
                // Contraindre la valeur entre 1 et 500
                const constrainedValue = Math.min(Math.max(numValue, 1), 500);
                handleChangeQuantity(constrainedValue, line._id);
              }}
              size="small"
              sx={{ width: '100px' }}
              inputProps={{
                min: 1,
                max: 500,
                step: 1,
              }}
              InputProps={{
                'aria-label': 'Quantité',
              }}
            />
          </FormControl>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {typeof line?.isAllocated === 'boolean' &&
            line.isValid === false ? (
              <Tooltip title="Référence produit invalide">
                <ErrorIcon
                  color="error"
                  sx={{
                    fontSize: '1.8em',
                    marginLeft: '10px',
                  }}
                />
              </Tooltip>
            ) : (
              (!(typeof line?.isValid === 'boolean') || line?.isLoading) && (
                <Tooltip title="Vérification des stocks en cours...">
                  <CircularProgress
                    sx={{
                      width: '1.8em !important',
                      height: '1.8em !important',
                      marginLeft: '10px',
                    }}
                  />
                </Tooltip>
              )
            )}
            {line?.isAllocated && !line?.isLoading && (
              <Tooltip title="Stock alloués">
                <CheckCircleIcon
                  sx={{ fontSize: '1.8em', marginLeft: '10px' }}
                  color="success"
                />
              </Tooltip>
            )}
            {line?.isAllocated === false &&
              line?.isValid !== false &&
              !line?.isLoading && (
                <Tooltip title="Vérifiez les stocks et l'association des pièces avec le préparateur, sauvegardez avant de confirmer">
                  <ReportProblemIcon
                    sx={{
                      fontSize: '1.2em',
                      marginLeft: '10px',
                      cursor: 'help',
                    }}
                    color="warning"
                  />
                </Tooltip>
              )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SavLines;
